import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const employeeContractAttachmentApi = createApi({
  reducerPath: 'employeeContractAttachmentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/employee_contract_attachments'
  }),
  endpoints: (builder) => ({
    getEmployeeContractAttachments: builder.query({
      query: (searchParams = '') => searchParams,
      providesTags: ['EmployeeContractAttachments']
    }),
    getEmployeeContractAttachment: builder.query({
      query: (id) => ({ url: `/${id}` }),
      transformResponse: (response) => response.employeeContractAttachment,
      providesTags: ['EmployeeContractAttachments']
    }),
    updateEmployeeContractAttachment: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body: { employee_contract_attachment: data }
      }),
      invalidatesTags: ['EmployeeContractAttachments']
    })
  })
})

const {
  useGetEmployeeContractAttachmentQuery,
  useUpdateEmployeeContractAttachmentMutation,
  useGetEmployeeContractAttachmentsQuery
} = employeeContractAttachmentApi

export {
  employeeContractAttachmentApi,
  useGetEmployeeContractAttachmentQuery,
  useUpdateEmployeeContractAttachmentMutation,
  useGetEmployeeContractAttachmentsQuery
}
